<template>
    <slide-transition>
        <section v-if="isVisible" class="stf-alert" :class="{ 'stf-alert--error': type === 'error' }">
            <div class="stf-alert-wrapper">
                <div v-if="$slots.icon" class="stf-alert-icon">
                    <slot name="icon"></slot>
                </div>
                <div class="stf-alert-content">
                    <slot></slot>
                </div>
                <button
                    v-if="closable"
                    class="stf-alert-close"
                    aria-label="Close alert"
                    @click="handleClose"
                >
                    <StfIcon icon="xMark" size="small" color="black" />
                </button>
            </div>
        </section>
    </slide-transition>
</template>

<script setup lang="ts">
import StfIcon from '@/ui/icon/StfIcon.vue';
import { ref, watch } from 'vue';
import SlideTransition from '@/transitions/slide-transition.vue';

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: true
    },
    closable: {
        type: Boolean,
        default: false
    },
    type: {
        type: String,
        default: 'info',
        validator: (value: string) => ['info', 'error'].includes(value)
    }
});

const emit = defineEmits(['update:modelValue']);

const isVisible = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
    isVisible.value = newValue;
});


const handleClose = () => {
    isVisible.value = false;
    emit('update:modelValue', false);
};
</script>

<style lang="scss">
@use "bulma/sass/utilities/mixins";
@use '@/assets/sass/_variables' as vars;

.stf-alert {
  width: 100%;
  border-radius: 4px;
  background-color: vars.$color-info;

  &--error {
    background-color: vars.$color-error-light;
    border: 1px solid vars.$color-error;
  }

  &-wrapper {
    display: flex;
    align-items: flex-start;
    padding: 24px 16px;
    position: relative;
    gap: 16px;

    @include mixins.mobile {
      padding: 20px 12px;
    }
  }

  &-icon {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  &-content {
    flex: 1;
  }

  &-close {
    display: flex;
    align-items: flex-start;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }
}
</style>
